import DropdownSelectMultiOption from 'components/Common/DropdownSelectMultiOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Row, Spinner } from "reactstrap";
import { getAllPlaceTravel, getAllPlaceWeathers, getInfoWeather } from "../../../store/thunks";
import ModalConfigGenerate from './components/ModalConfigGenerate';
import ModalGenerate from './components/ModalGenerate';
import HighlightText from 'pages/News/Components/HighlightText';
import SpinnerScreen from 'pages/News/Components/SpinnerScreen';
import ModalImport from './components/ModalImport';

export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'popularity';

registerLocale('en', en);
registerLocale('ko', ko);

const WeatherPlace = (activeTab?: any) => {
    let document_w: any = window.document;
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const [infoWeather, setInfoWeather] = useState<any>(null);

    const [listProvince, setListProvince] = useState<any[]>([]);
    const [listCity, setListCity] = useState<any[]>([]);

    const [provinceSpecialCitySearch, setProvinceSpecialCitySearch] = useState<any>(null);
    const [cityCountyDistrictSearch, setCityCountyDistrictSearch] = useState<any>(null);

    const [isLoadingInfoWeather, setIsLoadingInfoWeather] = useState<boolean>(false);

    const [isOpenModalImport, setIsOpenModalImport] = useState<boolean>(false);

    const [isOpenModalGenerate, setIsOpenModalGenerate] = useState<boolean>(false);

    const [isOpenModalConfigPrompt, setIsOpenModalConfigPrompt] = useState<boolean>(false);

    const searchData = async () => {
        try {
            if (!cityCountyDistrictSearch?.length && !provinceSpecialCitySearch?.length) {
                return;
            }
            setIsLoadingInfoWeather(true);
            const query = {
                city_names: cityCountyDistrictSearch?.length ? cityCountyDistrictSearch?.map((item: any) => item.value).join(',') : (provinceSpecialCitySearch?.length ? provinceSpecialCitySearch?.map((item: any) => item.value).join(',') : ''),
            };
            const res: any = await getInfoWeather(query);
            setInfoWeather(res?.data || null);
            setIsLoadingInfoWeather(false);
        } catch (error: any) {
            return error;
        }
    };

    const resetData = () => {
        setInfoWeather(null);
        setProvinceSpecialCitySearch((_prev: any) => null);
        setCityCountyDistrictSearch((_prev: any) => null);
    };

    const triggerRefresh = async () => {
        setIsOpenModalGenerate(false);
    }
    //End::Update

    const handleCallAllOption = async () => {
        try {
            const [res1]: any = await Promise.all([getAllPlaceTravel()]);
            const _tree = res1?.data?.tree;
            const _listProvince = _tree?.map((_p: any) => ({ label: _p?.name, province_id: `${_p?.id}`, value: `${_p?.name}` }));
            const _listCity = _tree?.flatMap((_p: any) => _p?.cities?.map((_c: any) => ({ label: _c?.name, province_id: `${_p?.id}`, city_id: `${_c?.id}`, value: `${_c?.name}` })));
            setListProvince((_prev) => _listProvince || []);
            setListCity((_prev) => _listCity || []);
        } catch (error: any) {
            return error;
        }
    };

    const listCityFilter = useMemo(() => {
        const _provinceIds = (provinceSpecialCitySearch || [])?.map((item: any) => String(item.province_id));
        return listCity?.filter((_c: any) => (_provinceIds?.includes(String(_c?.province_id)) || !_provinceIds?.length));
    }, [listCity, provinceSpecialCitySearch]);


    const handleShowModalGenerate = () => {
        setIsOpenModalGenerate(true);
    }

    const handleShowModalImport = () => {
        setIsOpenModalImport(true);
    }

    useEffect(() => {
        handleCallAllOption();
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.NEWS_WEATHER, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm-1">
                                        <div>
                                            <h5 className="card-title mb-0">

                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-sm-11 text-end">
                                        {isHavePermissionRole(ROLES_FOR_APP.NEWS_WEATHER, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                                            onClick={() => handleShowModalImport()}
                                        >
                                            <i className="ri-upload-line align-bottom"></i>
                                            <span className="ms-1">{t('Button Import Bulk Generate Weather News')}</span>
                                        </button>)}
                                        {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_WEATHER, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-primary add-btn rounded-pill ms-2"
                                            onClick={() => setIsOpenModalConfigPrompt((_prev: any) => true)}
                                        >
                                            <i className="ri-settings-line align-bottom"></i>
                                            <span className="ms-1">{t('Config Generate')}</span>
                                        </button>)}
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-1">
                                    <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('Province / Special City')} isShow={true}>
                                            <DropdownSelectMultiOption
                                                name={`province_special_city`}
                                                dataList={listProvince}
                                                placeholder={`${t("Province / Special City")}...`}
                                                className="dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                isHaveMoreInfo={true}
                                                initialValue={provinceSpecialCitySearch || null}
                                                onChangeSelect={(e: any) => {
                                                    setProvinceSpecialCitySearch(e)
                                                }}
                                                isHasOptionAll={true}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('City / County / District')} isShow={true}>
                                            <DropdownSelectMultiOption
                                                name={`city_county_district`}
                                                dataList={listCityFilter}
                                                placeholder={`${t("City / County / District")}...`}
                                                className="search-filter-category-type dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                initialValue={cityCountyDistrictSearch || null}
                                                isHaveMoreInfo={true}
                                                onChangeSelect={(e: any) => {
                                                    setCityCountyDistrictSearch(e)
                                                }}
                                                isHasOptionAll={true}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={12} md={12} lg={4} xl={8} xxl={8} className="hstack gap-1 justify-content-center justify-content-lg-start mt-3 mt-xl-2">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isLoadingInfoWeather}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                disabled={isLoadingInfoWeather}
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            {/* <div className="border border-dashed border-top-0 border-end-0 border-start-0 px-3 py-3">
                                <Col sm={12} md={12} xl={12} className="my-0 mt-2 mt-md-0 text-start d-flex flex-wrap gap-3 justify-content-between align-items-center">
                                    {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_TASK_UPDATE, userPermissions) && <div
                                        className='d-flex flex-wrap gap-3 justify-content-between align-items-center'
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-soft-success"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleShowModalGenerate();
                                            }}
                                        >
                                            {t('Generate News')}
                                        </button>
                                    </div>}
                                    <div className="mt-3 mt-md-0">

                                    </div>
                                </Col>
                            </div> */}
                            <CardBody className="pt-3 position-relative" style={{ minHeight: '50dvh', maxHeight: '50dvh', overflowY: 'auto' }}>
                                {isLoadingInfoWeather ? <SpinnerScreen zIndex={9} isShow={true} textLoading={t('Getting Weather Info')} /> : (
                                    <>
                                        {!!infoWeather ? <div style={{ whiteSpace: 'pre-line', lineHeight: '170%', }}>
                                            <HighlightText text={infoWeather?.full_text || ''} keyword={infoWeather?.keyword || ''} is_highlight_date={true} />
                                        </div> :
                                            <div className="d-flex align-items-center justify-content-center" style={{ height: '40dvh' }}>
                                                <span className="text-muted fs-13">
                                                    {t('No Weather Info')}
                                                </span>
                                            </div>}
                                    </>
                                )}
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <ModalConfigGenerate
                isOpen={isOpenModalConfigPrompt}
                onClose={() => setIsOpenModalConfigPrompt((_prev: any) => false)}
            />

            <ModalGenerate
                isOpen={isOpenModalGenerate}
                listPlace={listCity || []}
                onClose={() => setIsOpenModalGenerate(false)}
                onRefresh={() => triggerRefresh()}
            />

            <ModalImport
                isOpen={isOpenModalImport}
                onRefresh={triggerRefresh}
                onClose={() => setIsOpenModalImport(false)}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default WeatherPlace;